import { render, staticRenderFns } from "./sushi.vue?vue&type=template&id=ba346fe0&scoped=true"
import script from "./sushi.vue?vue&type=script&lang=js"
export * from "./sushi.vue?vue&type=script&lang=js"
import style0 from "./sushi.vue?vue&type=style&index=0&id=ba346fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba346fe0",
  null
  
)

export default component.exports